import React, {useContext, useEffect, useState} from 'react'
import {SessionContext} from 'Utils/sessions';
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import s from './styles/Dashboard.module.scss'
import SideBar from 'Components/Nav/SideBar';
import {setSessionCookie} from "../Utils/sessions";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import {AdminApi} from "../Api/AdminApi";
import {Tab, Tabs} from "react-bootstrap";

export const STUDENT_FILTERS = ['Current', 'Prospective', 'Active', 'Inactive', 'Verified', 'Unverified', 'Incomplete Signup', 'Completed Profile', 'Incomplete Profile'];

// Sample data for the chart
const DATA = [
    { time: 'Jan', value: 4000.0 },
    { time: 'Feb', value: 3000 },
    { time: 'Mar', value: 2000 },
    { time: 'Apr', value: 2780 },
    { time: 'May', value: 1890 },
    { time: 'Jun', value: 2390 },
    { time: 'Jul', value: 3490 },
];

const UserDashboard = () => {
    const {session} =  useContext(SessionContext);
    const [userPageData, setUserPageData] = useState(null);
    const userTableHeader = ['ID', 'First Name', 'Last Name', 'Email', 'Role', 'School', 'TOS', 'Verified', 'Signup Completed']
    const [refreshing, setRefreshing] = useState(false)
    const [filerOpen, setFilterOpen] = useState(false)
    const [topic, setTopic] = useState('')
    const [tab, setTab] = useState('Table')

    function toggleFilter() {
        setFilterOpen(!filerOpen)
    }

    function updateTopic(e) {
        setTopic(e?.target?.value.replaceAll(' ', '-'))
        setFilterOpen(false)
    }

    useEffect(() => {
        AdminApi.User.getAdminPageUserData({}, session.jwt).then(res => {
            setUserPageData(res.data);
        }).catch(error => {
            if (error.message?.includes( '404')) {
                setSessionCookie({})
                window.location.href = window.location.hostname
            }
        })
    }, [session.jwt])

    const filterUser = (user) => {
        const currentTopic = topic.toLowerCase()
        if (currentTopic === 'current') {
            return user.studentType.toLowerCase() === 'current'
        } else if (currentTopic === 'prospective') {
            return user.studentType.toLowerCase() === 'prospective'
        } else if (currentTopic === 'active') {
            return user.active
        } else if (currentTopic === 'inactive') {
            return !user.active
        } else if (currentTopic === 'verified') {
            return user.verified
        } else if (currentTopic === 'unverified') {
            return !user.verified
        } else if (currentTopic === 'incomplete-signup') {
            return !user.tos
        } else if (currentTopic === 'completed-profile') {
            return user.profileCompleted
        } else if (currentTopic === 'incomplete-profile') {
            return !user.profileCompleted
        } else {
            return true
        }
    }

    const refreshUserCache = () => {
        setRefreshing(true)
        AdminApi.User.refreshUserCache().then(res => {
            AdminApi.User.getAdminPageUserData({}, session.jwt).then(res => {
                setUserPageData(res.data);
                setRefreshing(false)
            }).catch(error => {
                setRefreshing(false)
            })
        }).catch(error => {
            setRefreshing(false)
        })
    }

    return <div>
        <SideBar session={session} title={"Manage Users"}>
            <div className={s.adminDashboard}>
                <main className={s.dataSection}>
                    <h3 className='heading'>Showing {(userPageData?.users ?? []).filter(filterUser).length} Users</h3>
                    <div className={s.dataTableContainer}>
                        <Tabs className='mb-4 '
                              activeKey={tab}
                              onSelect={(k) => setTab(k)} >
                            <Tab eventKey="Table" title={<span className='d-flex align-items-center'>Table</span>}>
                                <UserTable headers={userTableHeader} data={(userPageData?.users ?? []).filter(filterUser)}/>
                            </Tab>
                            <Tab eventKey="Daily Average Signup" title={<span className='d-flex align-items-center'>Daily Average Signup</span>}>
                                <UserGraph data={userPageData?.dailyGrowthEntries ?? DATA}/>
                            </Tab>
                            <Tab eventKey="10 Day Total" title={<span className='d-flex align-items-center'>10 Day Total</span>}>
                                <UserGraph data={userPageData?.movingTotalGrowthEntries ?? DATA}/>
                            </Tab>
                            <Tab eventKey="Total Growth History" title={<span className='d-flex align-items-center'>Total Growth History</span>}>
                                <UserGraph data={userPageData?.userGrowthHistory ?? DATA}/>
                            </Tab>
                        </Tabs>
                    </div>
                </main>
                <aside className={s.filterSection}>
                    <Button onClick={refreshUserCache} disabled={refreshing}
                            className={`btnFill wide d-block p-2 fs-16 fw-bold ${s.refreshCacheButton}`}>{refreshing ? "Refreshing..." : "Refresh User Cache"}</Button>
                    <Card className={s.filterCard}>
                        <Card.Title className={s.filterCardHeader}>
                            <div className={s.filterCardTitle}>Users</div>
                        </Card.Title>
                        <Card.Body className={'my-1'}>
                            <div><strong>Total:</strong> {userPageData?.users?.length ?? 0}</div>
                            <div><strong>Colleges Represented:</strong> {userPageData?.registeredColleges?.length ?? 0}</div>
                            <div><strong>Colleges With Mentors:</strong> {userPageData?.registeredColleges?.length ?? 0}</div>
                        </Card.Body>
                    </Card>
                    <Card className={s.filterCard}>
                        <Card.Title className={s.filterCardHeader}>
                            <div className={s.filterCardTitle}>Filter Users</div>
                            <div className={s.filterCardFilterToggle}>
                                <Button className={`btnLink`}
                                        onClick={toggleFilter}>{filerOpen ? 'Close' : 'Edit'}</Button>
                            </div>
                        </Card.Title>
                        <div className={s.mobile}>
                            {filerOpen &&
                                <>
                                    <Card.Body className={'my-0'}>
                                        <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`}
                                                onClick={updateTopic} value={''}>All Users</Button>
                                        {STUDENT_FILTERS.map((blogTopic, idx) =>
                                            <Button key={idx}
                                                    className={`${s.topicButton} ${topic === blogTopic.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`}
                                                    onClick={updateTopic}
                                                    value={blogTopic.trim().toLowerCase().replaceAll(' ', '-')}>{blogTopic.trim()}</Button>
                                        )}
                                    </Card.Body>
                                </>
                            }
                        </div>
                        <div className={s.desktop}>
                            <Card.Body className={'my-1'}>
                                <Button className={`${s.topicButton} ${topic === '' ? s.active : ''}`}
                                        onClick={updateTopic} value={''}>All Users</Button>
                                {STUDENT_FILTERS.map((blogTopic, idx) =>
                                    <Button key={idx}
                                            className={`${s.topicButton} ${topic === blogTopic.trim().toLowerCase().replaceAll(' ', '-') ? s.active : ''}`}
                                            onClick={updateTopic}
                                            value={blogTopic.trim().toLowerCase().replaceAll(' ', '-')}>{blogTopic.trim()}</Button>
                                )}
                            </Card.Body>
                        </div>
                    </Card>
                </aside>
            </div>
        </SideBar>
    </div>
}

const UserTable = ({headers, data}) => {
    return (
        <table className={s.dataTable}>
            <thead className={s.dataTableHeader}>
            <tr>
                {headers.map((header) => (
                    <th key={header} scope="col">
                        {header}
                    </th>
                ))}
            </tr>
            </thead>
            <tbody>
            {(data.length > 0 ? data : [{}]).toSorted((a, b) => b.id - a.id).map((row) => (
                <tr key={row.id} className={s.dataTableEntry}>
                    <td className={'py-4'}>
                        <button>
                            {row.id}
                        </button>
                    </td>
                    <td className={'px-6 py-4'}>
                        {row.firstName}
                    </td>
                    <td className={'px-6 py-4'}>
                        {row.lastName}
                    </td>
                    <td className={'px-6 py-4'}>
                        {row.email}
                    </td>
                    <td className="px-6 py-4">
                        <span className={` ${s.roleType} ${
                            row.role === 'CURRENT' ? s.currentStudentRoleType :
                                row.role === 'PROSPECTIVE' ? s.prospectiveStudentRoleType :
                                    ''
                        }`}>
                          {row.role}
                        </span>
                    </td>
                    <td className={'px-6 py-4'}>
                        {row.school ?? row.role === 'CURRENT' ? 'Not Set' : row.role === 'PROSPECTIVE' && 'High School'}
                    </td>
                    <td className={'px-6 py-4'}>
                        <span className={` ${s.roleType} ${
                            ((row.tos != null) && JSON.stringify(row.tos)) === 'true' ? s.positiveMarker :
                                ((row.tos != null) && JSON.stringify(row.tos)) === 'false' ? s.negativeMarker :
                                    ''
                        }`}>
                          {((row.tos != null) && JSON.stringify(row.tos))}
                        </span>
                    </td>
                    <td className={'px-6 py-4'}>
                        <span className={` ${s.roleType} ${
                            ((row.verified != null) && JSON.stringify(row.verified)) === 'true' ? s.positiveMarker :
                                ((row.verified != null) && JSON.stringify(row.verified)) === 'false' ? s.negativeMarker :
                                    ''
                        }`}>
                          {((row.verified != null) && JSON.stringify(row.verified))}
                        </span>
                    </td>
                    <td className={'px-6 py-4'}>
                        {new Date(row.id).toLocaleDateString()} at {new Date(row.id).toLocaleTimeString()}
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
};

const UserGraph = ({data}) => {
    const dataValues = data.map(item => item.value);
    const dataMin = Math.min(...dataValues);
    const dataMax = Math.max(...dataValues);

    const yAxisDomain = [
        Math.floor((dataMin - 5) >= 0 ? (dataMin - 5) : 0), // 5 units of padding below
        Math.ceil(dataMax + 5)   // 5 units of padding above
    ];

    return (
        <>
            {data ?
                <>
                    <ResponsiveContainer width="100%" height={500}>
                        <LineChart
                            data={data}
                            margin={{
                                top: 0,
                                right: 5,
                                left: 5,
                                bottom: 0,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="time" />
                            <YAxis domain={yAxisDomain} />
                            <Tooltip />
                            <Legend />
                            <Line
                                type="monotone"
                                dataKey="value"
                                stroke="#8884d8"
                                activeDot={{ r: 8 }}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </>
                :
                <>
                    <div className={s.shimmerPurple} style={{width: '100%', height: '500px'}}></div>
                </>
            }
        </>
    );
}

export default (UserDashboard);
